<div class="modal-body" *ngIf="photo">
    <app-photo-editor [showValidation]="showValidation" [photo]="photo" [defaultMapLocation]="defaultMapLocation">

    </app-photo-editor>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="showConfirmLeaving()">Cancel</button>
    <span>{{currentIndex + 1}} / {{files.length}}</span>
    <button type="button"
            class="btn btn-primary"
            (click)="saveAndNextPhoto()">{{currentIndex + 1 == files.length ? 'Save and Finish' : 'Save and Next'}}</button>
</div>
